import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import EditProfile from "../pages/EditProfile";
import BankDetails from "../pages/BankDetails";
import Address from "../pages/Address";
import Newsletter from "../pages/Newsletter";
import MyOrders from "../pages/MyOrders";

const Sidebar = () => {
  const [activeTab, setActiveTab] = useState("profile");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("profiledata");

    // Dispatch custom event to update Header
    window.dispatchEvent(new Event('loginStatusChanged'));

    navigate("/");
  };

  const renderPage = () => {
    switch (activeTab) {
      case "profile":
        return <EditProfile />;
      // case "bank":
      //   return <BankDetails />;
      case "orders":
        return <MyOrders />;
      case "address":
        return <Address />;
      case "newsletter":
        return <Newsletter />;
      default:
        return <EditProfile />;
    }
  };

  return (

<>
<div className="cover-bg-img">
        <div className="dz-bnr-inr-entry">
          <h1>Account</h1>
          <nav aria-label="breadcrumb" className="breadcrumb-row">
            <ul className="breadcrumb">
              <li className="breadcrumb-item"><Link to="/">Home</Link></li>
              <li className="breadcrumb-item">Account</li>
            </ul>
          </nav>
        </div>
      </div>
<section className="py-5">
<div className="container">
    <div className="row">
{/* Hamburger Menu Button for Mobile */}

<div className="d-lg-none mb-3 d-flex align-items-center justify-content-between">
  <h4 className="title mb-0">User panel</h4>
  <button
    className="hamburger-btn  "
    onClick={() => setIsSidebarOpen(!isSidebarOpen)}
    
  >
    ☰
  </button>


</div>


<div className={`col-xl-3 col-lg-4 ${isSidebarOpen ? 'd-block' : 'd-none d-lg-block'}`}>
      {/* SIDEBAR */}
     <div className=" account-sidebar-wrapper">
  <div className={`account-sidebar ${isSidebarOpen ? 'mobile-open' : ''}`} id="accountSidebar" onClick={() => setIsSidebarOpen(false)}>

    {/* Profile Header */}
    <div className="profile-head" onClick={(e) => e.stopPropagation()}>
      <div className="user-thumb">
        {/* <img
          className="rounded-circle"
          src={userIMG}
          alt="User"
        /> */}
      </div>
      <h5 className="title mb-0 fw-bold">User Panel</h5>
    </div>

    {/* Navigation */}
    <div className="account-nav" onClick={(e) => e.stopPropagation()}>
      <div className="nav-title bg-light">ACCOUNT SETTINGS</div>

      <ul className="account-info-list">
        <li
          className={activeTab === "profile" ? "active" : ""}
          onClick={() => {
            setActiveTab("profile");
            setIsSidebarOpen(false);
          }}
        >
          Edit Profile
        </li>
{/* 
        <li
          className={activeTab === "bank" ? "active" : ""}
          onClick={() => {
            setActiveTab("bank");
            setIsSidebarOpen(false);
          }}
        >
          Bank Details
        </li> */}
        <li
          className={activeTab === "orders" ? "active" : ""}
          onClick={() => {
            setActiveTab("orders");
            setIsSidebarOpen(false);
          }}
        >
          My orders
        </li>

        <li
          className={activeTab === "address" ? "active" : ""}
          onClick={() => {
            setActiveTab("address");
            setIsSidebarOpen(false);
          }}
        >
          Address
        </li>

        <li
          className={activeTab === "newsletter" ? "active" : ""}
          onClick={() => {
            setActiveTab("newsletter");
            setIsSidebarOpen(false);
          }}
        >
          Newsletter
        </li>

        <li className="text-danger" onClick={() => {
          handleLogout();
          setIsSidebarOpen(false);
        }}>
          Logout
        </li>

      </ul>
    </div>

  </div>
</div>


</div>


      {/* CONTENT */}
<div className="col-xl-9 col-lg-8 account-wrapper">
      <div className="account-card">
        {renderPage()}
      </div>
    </div>

</div>

</div>

</section>

</>
  );
};

export default Sidebar;
